import React from 'react';
import { MessageCircle } from 'lucide-react';
import { brand } from '../data/mock';

export default function WhatsAppFloat() {
  const href = `https://wa.me/${brand.whatsapp}?text=${encodeURIComponent('Hi Durga Facility Management, I would like to enquire about your facility management services.')}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-xl hover:shadow-2xl hover:-translate-y-0.5 transition-all"
    >
      <span className="relative flex items-center justify-center w-6 h-6">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
        <MessageCircle size={18} className="relative" />
      </span>
      <span className="text-sm font-semibold hidden sm:block">Chat on WhatsApp</span>
    </a>
  );
}
